/* eslint-disable no-unused-vars */
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { RiShoppingBag3Line } from "react-icons/ri";
import { TiTick } from "react-icons/ti";

const ProposalOrderHeader = ({
    proposalId,
    onSave,
    isSaving = false,
    canEdit = true,
}) => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
            <div className="flex flex-col gap-1">
                <div className="flex items-center gap-3 flex-wrap">
                    <div className="w-10 h-10 rounded-xl bg-[#8B2433]/10 border border-[#8B2433]/20 flex items-center justify-center shrink-0">
                        <RiShoppingBag3Line className="w-5 h-5 text-[#8B2433]" />
                    </div>
                    <div>
                        <h2 className="text-2xl sm:text-3xl font-bold poppins-medium text-[#303030]">
                            Riepilogo Ordine
                        </h2>
                    </div>
                </div>
            </div>

            {/* Action Buttons: Salva (Commented out) + Torna indietro */}
            <div className="flex items-center gap-3 self-start sm:self-auto flex-wrap">
                {/* {canEdit && (
                    <button
                        type="button"
                        onClick={onSave}
                        disabled={isSaving}
                        className="rounded-full py-[6px] border-[2px] bg-[#fff] border-[#F2C3CA] px-5 text-[#8B2433] text-sm font-medium shadow-sm poppins-regular whitespace-nowrap hover:bg-[#8B2433] hover:text-white transition-colors cursor-pointer flex items-center gap-1.5 disabled:opacity-50 group"
                    >
                        {isSaving ? (
                            <span className="w-4 h-4 border-2 border-[#8B2433] group-hover:border-white border-t-transparent rounded-full animate-spin shrink-0" />
                        ) : (
                            <TiTick className="w-5 h-5 text-emerald-600 group-hover:text-white transition-colors shrink-0" />
                        )}
                        <span>{isSaving ? "Salvataggio..." : "Salva"}</span>
                    </button>
                )} */}

                <button
                    type="button"
                    onClick={() => navigate('/admin/proposals')}
                    className="rounded-full py-[6px] border-[2px] bg-[#fff] border-[#F2C3CA] px-5 text-[#8B2433] text-sm font-medium shadow-sm poppins-regular whitespace-nowrap shrink-0 hover:bg-[#8B2433] hover:text-white transition-colors cursor-pointer"
                >
                    Torna indietro
                </button>
            </div>
        </div>
    );
};

ProposalOrderHeader.propTypes = {
    proposalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSave: PropTypes.func,
    isSaving: PropTypes.bool,
    canEdit: PropTypes.bool,
};

export default ProposalOrderHeader;

